import React, { useState, useEffect, useRef } from 'react';
import { selectedWorkData } from '../data/mock';

const SelectedWork = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [visibleIndexes, setVisibleIndexes] = useState(new Set());
  const imageRefs = useRef([]);

  useEffect(() => {
    const observers = [];
    
    imageRefs.current.forEach((ref, index) => {
      if (ref) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                setVisibleIndexes(prev => new Set([...prev, index]));
              }
            });
          },
          { threshold: 0.3 }
        );
        
        observer.observe(ref);
        observers.push(observer);
      }
    });

    return () => {
      observers.forEach(observer => observer.disconnect());
    };
  }, []);

  return (
    <section className="selected-work-section">
      <div className="container">
        <div className="selected-work-header">
          <div className="work-year-range">[20' — PORTFOLIO — 25']</div>
          <h2 className="work-section-label">( SELECTED WORK )</h2>
        </div>

        <div className="selected-work-grid">
          {selectedWorkData.map((work, index) => (
            <a
              key={work.id}
              href={work.website}
              target="_blank"
              rel="noopener noreferrer"
              className="work-item"
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className="work-number">[{work.id}]</div>
              
              <div 
                className="work-image-wrapper"
                ref={el => imageRefs.current[index] = el}
              >
                <img 
                  src={work.image} 
                  alt={work.client}
                  className={`work-image ${visibleIndexes.has(index) ? 'mobile-visible' : ''}`}
                />
              </div>

              <div className="work-details">
                <div className="work-client-name">({work.client}.)</div>
                <div className="work-category">{work.category}</div>
                <p className="work-description">{work.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SelectedWork;
